import { createContext, useContext, useMemo } from 'react';
import useAuth from '../hooks/useAuth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useAuth();

  const value = useMemo(
    () => ({
      ...auth,
      user: auth.currentUser,
      isAuthenticated: Boolean(auth.currentUser),
    }),
    [auth],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used inside AuthProvider');
  }

  return context;
}
